import React, { useState, useContext, useEffect } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { Link } from "gatsby";

import NavMenu from "./NavMenu.jsx";

import { cookieWindowShow } from "../../src/redux/actions/loginActions";
import CookieDialog from "../components/AC-Cookie/CookieDialog";
import Profile from "./Profile.jsx";
import ProfileNew from "./ProfileNew.jsx";

import { setHTMLElementFixedPosition } from "../functions/Utilities.js";
import SearchBarMobile from "../components/AC-Search/components/SearchBarMobile";
import WishList from "../components/AC-WishList/components/WishListCustomModal.jsx";
import { I18nContext } from "../i18n/index";

import { useLocation } from "@reach/router";
import { handleMobileOrDesktop } from "../redux/actions/mainActions.js";
import { updateBrandsGeolocation } from "../redux/actions/geoLocationActions.js";
import demoLogo from "../assets/img/demoLogo.png";
import SearchBar from "./SearchHelper";

export default function MenuTopBar({ brands }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { translate } = useContext(I18nContext);

  useEffect(() => {
    //BRANDS GEOLOCATION
    dispatch(updateBrandsGeolocation(brands));
  }, []);

  const langCode = useSelector((state) => state.mainReducer.lang, shallowEqual);

  const [loginModalOpened, setLoginModalOpened] = useState(false);

  const compareListState = useSelector(
    (state) => state.compareListReducer.compareList,
    shallowEqual
  );

  const navCatsState = useSelector(
    (state) => state.menuReducer.navCats,
    shallowEqual
  );

  const isMobileState = useSelector(
    (state) => state.mainReducer.isMobile,
    shallowEqual
  );

  //#region screen width listener starts
  let initialMobile;
  if (typeof window !== "undefined") {
    initialMobile = window.innerWidth;
  }

  const [currentScreenWidth, setCurrentScreenWidth] = useState(initialMobile);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setCurrentScreenWidth(window.innerWidth);
      };
      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);

  let isMobile;
  const mobileSize = 768;
  useEffect(() => {
    if (currentScreenWidth > mobileSize) {
      isMobile = false;
    } else {
      isMobile = true;
    }
    dispatch(handleMobileOrDesktop({ isMobile, currentScreenWidth }));
  }, [currentScreenWidth]);

  //#endregion screen width listener starts

  const handleChangeBtnClicked = () => {
    const button = document.getElementById("locationChangeBtn");
    button.click();
  };

  // Lee
  // ? redux ?? cookieWindowState(null)
  // ???? cookie dialog
  let cookieWindowState = useSelector(
    (state) => state.loginReducer.cookieWindow,
    shallowEqual
  );

  const [navMenuOpen, setNavMenuOpen] = useState(false);

  const toggleDrawer = () => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setNavMenuOpen(!navMenuOpen);
  };

  useEffect(() => {
    setHTMLElementFixedPosition(navMenuOpen);
    return () => {
      setHTMLElementFixedPosition(false);
    };
  }, [navMenuOpen]);

  const handleCategoryChange = (cid, cat, parents, longdesc) => {
    // let catName = cat;
    if (isMobileState) {
      setNavMenuOpen(!navMenuOpen);
    }
  };

  useEffect(() => {
    // (in Redux) cookieWindow = cookieAcceptance(null)    (in local)
    if (typeof localStorage !== undefined) {
      let decision = localStorage.getItem("cookieAcceptance");
      if (decision) {
        dispatch(cookieWindowShow(decision.isAccept));
      }
    }
  });

  // ??handler???
  // (in Redux) cookieWindow = true
  const changeCookieInRedux = () => {
    dispatch(cookieWindowShow(true));
  };

  // ??handler???
  // (in local)   cookieAcceptance = {"date": , "consent": , "isAccept": }
  const acceptCookieHandler = () => {
    let consent = {
      date: new Date(),
      consent: "Cookies accepted.",
      isAccept: true,
    };
    if (typeof localStorage !== undefined) {
      localStorage.setItem("cookieAcceptance", JSON.stringify(consent));
    }
  };

  const acceptCookieAndCloseWindow = () => {
    changeCookieInRedux();
    acceptCookieHandler();
  };

  const handleCompareIconClicked = () => {
    if (compareListState && compareListState.length > 0) {
      const btn = document.querySelector("#compare-collapse-btn");
      if (btn) btn.click();
    }
  };

  return (
    <>
      <nav
        className="nav-extended"
        style={{ background: "#fff", padding: "4px 0px" }}
      >
        <div className="nav-wrapper">
          <div className="header-container height50 mobilenondisplay1">
            <div className="nav-icons-container">
              {/* <div className="icon-container">
                <div className="icon-container login-icon-container">
                  <ProfileNew
                    modalOpenedByIcon={loginModalOpened}
                    setModalOpened={setLoginModalOpened}
                  />
                </div>
              </div> */}

              <div className="icon-container">
                <div className="login-icon-container">
                  <Link to={"/promote-your-products"}>
                    {isMobileState
                      ? "PROMOTE YOUR PRODUCTS"
                      : "PROMOTE YOUR PRODUCTS ON FURNITURE MARKETPLACE"}
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="header-container" style={{ height: "auto" }}>
            {isMobileState ? (
              <React.Fragment>
                <div className="icon-container">
                  <div className="icon-wrapper">
                    <i
                      open={navMenuOpen}
                      className="material-icons mobile-nav-icon"
                      onClick={toggleDrawer()}
                    >
                      <span></span>
                    </i>
                  </div>

                  <div className="logo-container">
                    <Link to={"/"} className="brand-logo logo-i">
                      <img
                        src={demoLogo}
                        alt="Virtuall Furniture Logo"
                        className="img-responsive"
                        style={{ maxWidth: "150px", height: "55px" }}
                      />
                    </Link>
                  </div>
                </div>
                <div className="mobile-nav-bar-container" open={navMenuOpen}>
                  <div
                    id="nav-menu-drawer"
                    className={
                      langCode === "ar"
                        ? "rtl nav-wrapper actual-nav"
                        : "nav-wrapper actual-nav"
                    }
                  >
                    <div className="nav-content-wrapper">
                      <div className="search-bar-container">
                        <div className="search-bar-wrapper">
                          <SearchBarMobile setNavMenuOpen={setNavMenuOpen} />
                        </div>
                      </div>
                      <ul className="staticMenu">
                        <li style={{ color: "#2aa841" }}>
                          <Link
                            onClick={() => {
                              if (isMobileState) {
                                setNavMenuOpen(!navMenuOpen);
                              }
                            }}
                            className="menuCat1"
                            to={"/"}
                          >
                            {translate("Home").toUpperCase()}
                          </Link>
                        </li>
                        {navCatsState.childs.map((cat) => {
                          let catName = cat.description;
                          let tempUrl = cat.URL;
                          tempUrl = tempUrl;

                          tempUrl = tempUrl.replace(`${langCode}/shop`, "shop");
                          return (
                            <li key={cat.cid}>
                              <Link
                                onClick={() => handleCategoryChange()}
                                className="menuCat"
                                style={{
                                  textTransform:
                                    catName != "by Brand" &&
                                    catName != "by Style"
                                      ? ""
                                      : null,
                                }}
                                to={"/" + tempUrl.replace("shop/", "")}
                              >
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: catName,
                                  }}
                                />
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                      <ul className="staticMenu">
                        <li>
                          <a
                            href="https://www.avetticommerce.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {translate("vm.footer_about").toUpperCase()}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ) : null}

            <div
              className="logo-container"
              className={
                isMobileState ? "hidden logo-container" : "logo-container"
              }
            >
              <Link to={"/"} className="brand-logo logo-i">
                <img
                  src={demoLogo}
                  alt="Virtuall Furniture Logo"
                  className="img-responsive"
                  style={{ maxWidth: "150px", height: "55px" }}
                />
              </Link>

              <SearchBar />
            </div>

            <div className="nav-icons-container">
              <div className="nav-icons-container">
                <div
                  onClick={handleCompareIconClicked}
                  className="icon-container compare-icon-container"
                >
                  <div className="icon-wrapper">
                    <i title="Compare" className="material-icons">
                      compare_arrows
                    </i>
                    <span
                      className="compare-icon-count"
                      style={
                        compareListState && compareListState.length > 0
                          ? {}
                          : { display: "none" }
                      }
                    >
                      {compareListState && compareListState.length}
                    </span>
                  </div>
                </div>

                <WishList />

                <div
                  id="cart-icon-btn"
                  className="icon-container"
                  onClick={handleChangeBtnClicked}
                >
                  <div className="icon-wrapper">
                    <i className="material-icons">location_on</i>
                  </div>
                </div>

                <div className="icon-container login-icon-container">
                  <Profile
                    modalOpenedByIcon={loginModalOpened}
                    setModalOpened={setLoginModalOpened}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <nav
        className={isMobileState ? "nav-extended hidden" : "nav-extended"}
        style={{
          boxShadow: "none",
          background: "#fff",
          padding: "0px",
          borderTop: ".1rem solid #f5f5f5",
          borderBottom: ".1rem solid #f5f5f5",
          marginBottom: "0px",
        }}
      >
        <div className="nav-wrapper">
          <div className="header-container">
            {cookieWindowState === null &&
            !location.pathname.includes("cookiepage") ? (
              <CookieDialog
                destination={"/cookiepage"}
                acceptCookieCloseDialog={acceptCookieAndCloseWindow}
              />
            ) : null}

            {!isMobileState ? <NavMenu /> : null}
          </div>
        </div>
      </nav>
    </>
  );
}
